// @ts-nocheck

export default function MyAlert(props) {
  var message = props['message'];
  var timer = 1700;
  if (typeof props['timer'] != 'undefined') {
    timer = props['timer'];
  }
  var type = 'info';
  if (typeof props['type'] != 'undefined') {
    type = props['type'];
  }
  Swal.fire({
    type: type,
    html: message,
    showConfirmButton: false,
    timer: timer,
    onClose: () => {
      if (typeof props['reload'] != 'undefined') {
        if (props['reload']) {
          location.reload();
        }
      }
      if (typeof props['redirect'] != 'undefined') {
        if (props['redirect']) {
          window.location.assign(props['redirect']);
        }
      }
    },
  });
}
